module.exports = __webpack_public_path__ + "img/logo-bhc.ed20fd3a.png";